var e4       = e4 || {},
    bredana = bredana || {},
    grecaptcha = grecaptcha || [];
    
( function () {
    'use strict';
    bredana.bootstrapInitialize = {
        init: function () {
            jQuery( '[data-toggle="tooltip"]' ).popover();
            
        }
    };
    bredana.forms = {
        init: function () {
            e4.util.require.js( e4.settings.require.jQueryValidate, function () {
                bredana.forms.bindEvents();
            });
        },
        bindEvents: function () {
            jQuery( '.js-b-form-dw-clickdimensions-signup' ).validate( {
                ignore: '.ignore',
                rules: {
                    hiddenRecaptcha: {
                        required: function () {
                            if ( grecaptcha.getResponse() === '' ) {
                                return true;
                            }
                            else {
                                const form = jQuery( '.js-b-form-dw-clickdimensions-signup' );
                                form.attr('action', actionLink);
                                bredana.forms.disableButton(form.find('.btn'));
                                return false;
                            }
                        }
                    }
                }
            } );
        },
        disableButton: function (btn) {
            console.log("Disable", btn);
            // btn.append('<span class="loader"></span>');
            // btn.prop('disabled', true);
        }
    };
}() );
